import { render, staticRenderFns } from "./EmployeeEducationCreateOrUpdate.vue?vue&type=template&id=1c9b4fb7&"
import script from "./EmployeeEducationCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./EmployeeEducationCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports